package one.healthium.login.ui.login

import androidx.compose.runtime.Immutable
import one.healthium.domain.user.models.SignInOptions

@Immutable
data class SignInUiOptions(
    val username: String = "",
    val password: String = ""
) {
    val options = if (username.isNotBlank() && password.isNotBlank()) {
        SignInOptions.Username(username.trim(), password.trim())
    } else {
        null
    }
}
